// removed by extract-text-webpack-plugin
module.exports = {"subtitle":"Hero__subtitle__Lzm7L","image":"Hero__image__2HtiO","title":"Hero__title__2lieL","fadeIn":"Hero__fadeIn__2ZKvJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Hero/Hero.css
// module id = 63
// module chunks = 0